import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { CaseAutomaticNotificationTriggerResponse } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-trigger/configuration-case-automatic-notification-trigger.dto'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { configurationCaseAutomaticNotificationTriggerService } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-trigger/configuration-case-automatic-notification-trigger.service'
import { store } from '@/store/store'

export const columnsDefCaseAutomaticNotificationTriggerGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.name'),
            field: 'name',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.actionType'),
            colId: 'actionType',
            field: 'actionType.translatedName',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.predefinedNotification'),
            field: 'predefinedCustomNotification.title',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface CaseAutomaticNotificationTriggerGridState extends CrudModelPaginatorLaboratory<CaseAutomaticNotificationTriggerResponse> {
    laboratoryId: number
}
export const initialCaseAutomaticNotificationTriggerGridState =
    (): CaseAutomaticNotificationTriggerGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.caseAutomaticNotificationTrigger',
        columnsDef: columnsDefCaseAutomaticNotificationTriggerGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationCaseAutomaticNotificationTriggerService, store.getters.labId),
        laboratoryId: store.getters.labId
    })
